$(document).ready(function () {
  "use strict";
  $("input,select").keydown(function (e) {
    if (e.which == 9) {
      var center = $(window).height() / 2;
      var top = $(this).offset().top;
      if (top > center)
        $(window).scrollTop(top - center);
    }
  });

  $("select").change(function () {
    this.style.backgroundImage = 'none';
  });
  $("select").focusout(function () {
    if ($(this).val() != "") {
      $(this).attr('style', 'background-image: none !important');
    }
  });

  $('select').on('select2:select', function (e) {
    var id = "#" + $(this).attr('id');
    if ($(this).val() != "") {
      $(id + " + .select2-container .selection [aria-labelledby='select2-" + $(this).attr('id') + "-container']").attr('style', 'background-image: none !important;opacity: 0.9 !important;');
    } else {
      $(id + " + .select2-container .selection [aria-labelledby='select2-" + $(this).attr('id') + "-container']").attr('style', 'background-image: ' + $(this).data("imgBg") + ' !important;opacity: 0.6 !important;');
    }
  });
  $('.js-example-data-ajax').on('select2:select', function (e) {
    if ($(this).val() != "0") {
      $('#searchclear').show();
    } else {
      $('#searchclear').hide();
    }
  });
  $('.jogador-especial-data-ajax').on('select2:select', function (e) {
    if ($(this).val() != "0") {
      $('#searchclear').show();
    } else {
      $('#searchclear').hide();
    }
  });

  $("#searchclear").click(function () {
    $(this).hide();
    $("#imgJogador").attr('src', "images/default.png");
    $(".js-example-data-ajax").select2('val', '0');
    $('.js-example-data-ajax').find("option").remove();
    $(".jogador-especial-data-ajax").select2('val', '0');
    $('.jogador-especial-data-ajax').find("option").remove();
  });

  $(".js-example-data-ajax").select2({
    ajax: {
      dataType: 'json',
      delay: 1000,
      allowClear: true,
      url: function (params) {
        return '/jogador/' + params.term;
      },
      processResults: function (data, params) {
        params.page = params.page || 1;

        return {
          results: data,
          pagination: {
            more: (params.page * 30) < data.total_count
          }
        };
      },
      cache: true
    },
    width: '100%',
    placeholder: 'Encontrar jogador',
    escapeMarkup: function (markup) {
      return markup;
    }, // let our custom formatter work
    minimumInputLength: 1,
    templateResult: formatRepoJogador,
    templateSelection: formatRepoJogador,
    language: {
      inputTooShort: function () {
        return "Informe parte do nome do jogador...";
      },
      inputTooLong: function (args) {
        return "Você digitou muito";
      },
      errorLoading: function () {
        return "Nada encontrado";
      },
      loadingMore: function () {
        return "Procurando resultados";
      },
      noResults: function () {
        return "Nada encontrado";
      },
      searching: function () {
        return "Procurando...";
      },
      maximumSelected: function (args) {
        return "Nada encontrado";
      }
    }
  });
  $(".jogador-especial-data-ajax").select2({
    ajax: {
      dataType: 'json',
      delay: 1000,
      minimumInputLength: 3,
      allowClear: true,
      url: function (params) {
        return '/api/jogador/futbin/' + params.term;
      },
      processResults: function (data, params) {
        params.page = params.page || 1;

        return {
          results: data,
          pagination: {
            more: (params.page * 30) < data.total_count
          }
        };
      },
      cache: true
    },
    width: '100%',
    dropdownCssClass: "select2-dropdown-jogador-especial",
    containerCssClass: "select2-container-jogador-especial",
    placeholder: 'Encontrar jogador',
    escapeMarkup: function (markup) {
      return markup;
    }, // let our custom formatter work
    minimumInputLength: 1,
    templateResult: formatRepoJogadorEspecial,
    templateSelection: formatRepoJogadorEspecial,
    language: {
      inputTooShort: function () {
        return "Informe parte do nome do jogador...";
      },
      inputTooLong: function (args) {
        return "Você digitou muito";
      },
      errorLoading: function () {
        return "Nada encontrado";
      },
      loadingMore: function () {
        return "Procurando resultados";
      },
      noResults: function () {
        return "Nada encontrado";
      },
      searching: function () {
        return "Procurando...";
      },
      maximumSelected: function (args) {
        return "Nada encontrado";
      }
    }
  });
});
function slugify(string) {
  const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
  const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
  const p = new RegExp(a.split('').join('|'), 'g')

  return string.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
}
function strContains(stringCompare, stringContains) {
  return stringCompare.indexOf(stringContains) != -1;
}
function formatRepoJogadorEspecial(resultado) {
  var urlImagemJogador = "https://cdn.futnext.com";
  var urlImagemResource = "/player/";
  var nationImage = resultado.hasOwnProperty('nation_image') ? resultado.nation_image : "";
  var teamImage = resultado.hasOwnProperty('club_image') ? resultado.club_image : "";
  if (resultado.loading) {
    return resultado.text;
  }
  if (!resultado.id || resultado.id == "0") {
    return '<span style="color:#959fa6;">' + resultado.text + '</span>';
  }
  if (resultado.hasOwnProperty('text') && resultado.text != "") {
    resultado = JSON.parse(resultado.text);
  }
  if (resultado.version.includes("SBC") || resultado.version.includes("Obj") || resultado.version.includes("POTM") || resultado.version.includes("Icon")) {
    return;
  }
  if (resultado.hasOwnProperty('nation_id')) {
    nationImage = "https://cdn.futbin.com/content/fifa20/img/nation/" + resultado.nation_id + ".png";
  }
  if (resultado.hasOwnProperty('team_id')) {
    teamImage = "https://cdn.futbin.com/content/fifa20/img/clubs/" + resultado.team_id + ".png";
  }
  if (resultado.hasOwnProperty('full_name')) {
    resultado.name = resultado.full_name;
  }
  var classVersion = (strContains(resultado.version, ":") ? slugify(resultado.version.split(":")[0]) : slugify(resultado.version)).toString();
  urlImagemJogador += urlImagemResource + resultado.asset_id + '.png';
  var markup = '<li class="regular-dd ui-menu-item" id="fsw_LI_1"> <a data-id="44079" id="fsw_A_2" tabindex="-1" class="ui-menu-item-wrapper"><img class="clubpicture" src="' + teamImage + '" id="fsw_IMG_3"> <img class="nationpicture" src="' + nationImage + '" id="fsw_IMG_4"> <img class="playerpicture" src="' + urlImagemJogador + '" id="fsw_IMG_5"> <span class="name" id="fsw_SPAN_6"><span style="font-weight: 600;" id="fsw_SPAN_7">' + resultado.name + '</span></span> <span class="position_ac_row" id="fsw_SPAN_8">(' + resultado.position + ')</span> <span style="" class="rating-search ut20 ' + classVersion + '" id="fsw_SPAN_9">' + resultado.rating + '</span> <span class="version_ac_row pull-right" id="fsw_SPAN_10">' + (strContains(resultado.version, ":") ? resultado.version.split(":")[0] : resultado.version).toString() + '</span> </a></li>';

  return markup;
}
function formatRepoJogador(repo) {
  var urlImagemJogador = "https://cdn.futnext.com";
  var urlImagemResource = "/player/";
  if (repo.loading) {
    return repo.text;
  }
  if (!repo.id || repo.id == "0") {
    return '<span style="color:#959fa6;">' + repo.text + '</span>';
  }

  if (repo.hasOwnProperty('text') && repo.text != "") {
    repo = JSON.parse(repo.text);
  }
  if (repo.hasOwnProperty('moment')) {
    urlImagemResource = "";
  }

  if (repo.hasOwnProperty('img')) {
    urlImagemJogador = repo.img;
  } else {
    urlImagemJogador += urlImagemResource + repo.id + '.png';
  }
  var nomeJogador = repo.hasOwnProperty('c') ? repo.c : repo.f + ' ' + repo.l;

  var botaoEditarOfertaPrecoCompraJogador = "";
  var campoOfertaPrecoCompraJogador = "";

  if (edicaoOfertaCompraJogadorHabilitada()) {
    var objPrecoJogador = getObjJogadorOfertaCompra(repo.id);
    var valorCompra = objPrecoJogador ? objPrecoJogador.oferta : obterInteiroDaString($("#formCompra input[name=max]").val());
    botaoEditarOfertaPrecoCompraJogador = '<a href="#" title="Editar Valor oferta de compra do jogador" onclick="App.SniperExtensao.aoEditarOfertaCompraJogador(event);" class="btn btn-sm btn-default float-right text-white mr-0 ml-1 btn-edit-valor-oferta-jogador"><i class="fas fa-edit"></i><span class="label-valor-oferta-jogador">' + valorCompra + '</span></a>';
    campoOfertaPrecoCompraJogador = '<input type="hidden" name="oferta_jogador_' + repo.id + '" value="' + valorCompra + '" />';
  }



  var markup = '<div class="container-jogador" data-id-item="' + repo.id + '" id="item' + repo.id + '">\n\
                <ul id="ui-id-1" tabindex="0" class="ui-menu ui-widget ui-widget-content ui-autocomplete ui-front quicksearch short" \n\
                style="display: block; top: -1973.25px; left: 564px;">\n\
                  <li class="regular-dd ui-menu-item">\n\
                    <a data-id="5" id="ui-id-55" tabindex="-1" class="ui-menu-item-wrapper ui-menu-item-alternate">\n\
                    <img class="playerpicture" style="max-width: 25px;" src="' + urlImagemJogador + '">\n\
                    <span class="name" style="font-size: 10px;text-transform: uppercase;font-weight: 700;">' + nomeJogador + '</span>\n\
                    '+ botaoEditarOfertaPrecoCompraJogador + '\n\
                    <span class="badge green  stat_text_green rounded p-2 font-weight-normal pull-right mt-2 player-info-rating" style="margin-top: 0px !important;padding: 8px 5px !important;">' + repo.r + '</span>\n\
                    </a>\n\
                  '+ campoOfertaPrecoCompraJogador + '\n\
                  </li>\n\
                </ul>\n\
               </div>';
  return markup;
}

function edicaoOfertaCompraJogadorHabilitada() {
  try {
    return App.Util.editarPrecoJogadoresSelecionados;
  } catch (e) {
    return false;
  }
}

function getObjJogadorOfertaCompra(id) {
  var jogadoresOfertaCompra = JSON.parse(window.localStorage.getItem('jogadores_oferta_compra'));
  if (jogadoresOfertaCompra) {
    return App.Util.getItemArrayById(jogadoresOfertaCompra, id, null);
  }

  return null
}


function obterInteiroDaString(str) {
  return parseInt(str.replace(/[^0-9]/gi, ''));
}

function formatRepoSelection(repo) {
  return repo.full_name || repo.text;
}
function formatOptionsSelect(state) {
  if (!state.id) {
    return state.text;
  }
  var baseUrlImg = $(state.element).data('imgSrc');
  var $state = $(
    '<span><img src="' + baseUrlImg + '" class="img-flag" /> ' + state.text + '</span>'
  );
  return $state;
}

var MD5 = function (string) {

  function RotateLeft(lValue, iShiftBits) {
    return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
  }

  function AddUnsigned(lX, lY) {
    var lX4, lY4, lX8, lY8, lResult;
    lX8 = (lX & 0x80000000);
    lY8 = (lY & 0x80000000);
    lX4 = (lX & 0x40000000);
    lY4 = (lY & 0x40000000);
    lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
    if (lX4 & lY4) {
      return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
    }
    if (lX4 | lY4) {
      if (lResult & 0x40000000) {
        return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
      } else {
        return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
      }
    } else {
      return (lResult ^ lX8 ^ lY8);
    }
  }

  function F(x, y, z) {
    return (x & y) | ((~x) & z);
  }
  function G(x, y, z) {
    return (x & z) | (y & (~z));
  }
  function H(x, y, z) {
    return (x ^ y ^ z);
  }
  function I(x, y, z) {
    return (y ^ (x | (~z)));
  }

  function FF(a, b, c, d, x, s, ac) {
    a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac));
    return AddUnsigned(RotateLeft(a, s), b);
  }
  ;

  function GG(a, b, c, d, x, s, ac) {
    a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac));
    return AddUnsigned(RotateLeft(a, s), b);
  }
  ;

  function HH(a, b, c, d, x, s, ac) {
    a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac));
    return AddUnsigned(RotateLeft(a, s), b);
  }
  ;

  function II(a, b, c, d, x, s, ac) {
    a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac));
    return AddUnsigned(RotateLeft(a, s), b);
  }
  ;

  function ConvertToWordArray(string) {
    var lWordCount;
    var lMessageLength = string.length;
    var lNumberOfWords_temp1 = lMessageLength + 8;
    var lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
    var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
    var lWordArray = Array(lNumberOfWords - 1);
    var lBytePosition = 0;
    var lByteCount = 0;
    while (lByteCount < lMessageLength) {
      lWordCount = (lByteCount - (lByteCount % 4)) / 4;
      lBytePosition = (lByteCount % 4) * 8;
      lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount) << lBytePosition));
      lByteCount++;
    }
    lWordCount = (lByteCount - (lByteCount % 4)) / 4;
    lBytePosition = (lByteCount % 4) * 8;
    lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
    lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
    lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
    return lWordArray;
  }
  ;

  function WordToHex(lValue) {
    var WordToHexValue = "", WordToHexValue_temp = "", lByte, lCount;
    for (lCount = 0; lCount <= 3; lCount++) {
      lByte = (lValue >>> (lCount * 8)) & 255;
      WordToHexValue_temp = "0" + lByte.toString(16);
      WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length - 2, 2);
    }
    return WordToHexValue;
  }
  ;

  function Utf8Encode(string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";

    for (var n = 0; n < string.length; n++) {

      var c = string.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }

    }

    return utftext;
  }
  ;

  var x = Array();
  var k, AA, BB, CC, DD, a, b, c, d;
  var S11 = 7, S12 = 12, S13 = 17, S14 = 22;
  var S21 = 5, S22 = 9, S23 = 14, S24 = 20;
  var S31 = 4, S32 = 11, S33 = 16, S34 = 23;
  var S41 = 6, S42 = 10, S43 = 15, S44 = 21;

  string = Utf8Encode(string);

  x = ConvertToWordArray(string);

  a = 0x67452301;
  b = 0xEFCDAB89;
  c = 0x98BADCFE;
  d = 0x10325476;

  for (k = 0; k < x.length; k += 16) {
    AA = a;
    BB = b;
    CC = c;
    DD = d;
    a = FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
    d = FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
    c = FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
    b = FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
    a = FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
    d = FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
    c = FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
    b = FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
    a = FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
    d = FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
    c = FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
    b = FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
    a = FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
    d = FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
    c = FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
    b = FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
    a = GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
    d = GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
    c = GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
    b = GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
    a = GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
    d = GG(d, a, b, c, x[k + 10], S22, 0x2441453);
    c = GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
    b = GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
    a = GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
    d = GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
    c = GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
    b = GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
    a = GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
    d = GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
    c = GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
    b = GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
    a = HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
    d = HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
    c = HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
    b = HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
    a = HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
    d = HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
    c = HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
    b = HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
    a = HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
    d = HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
    c = HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
    b = HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
    a = HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
    d = HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
    c = HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
    b = HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
    a = II(a, b, c, d, x[k + 0], S41, 0xF4292244);
    d = II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
    c = II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
    b = II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
    a = II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
    d = II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
    c = II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
    b = II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
    a = II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
    d = II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
    c = II(c, d, a, b, x[k + 6], S43, 0xA3014314);
    b = II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
    a = II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
    d = II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
    c = II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
    b = II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
    a = AddUnsigned(a, AA);
    b = AddUnsigned(b, BB);
    c = AddUnsigned(c, CC);
    d = AddUnsigned(d, DD);
  }

  var temp = WordToHex(a) + WordToHex(b) + WordToHex(c) + WordToHex(d);

  return temp.toLowerCase();
}
